import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appSelectOnClick]'
})
export class SelectOnClickDirective {

  constructor(private el: ElementRef) { }

  @HostListener('focus', ['$event'])
  onFocus($event) {
    setTimeout(() => {
      if (this.el.nativeElement.shadowRoot) {
        const nativeEl: HTMLInputElement = this.el.nativeElement.shadowRoot.querySelector('input.native-input');
        if (nativeEl) {
          if (!window.getSelection().toString()) {
            // Required for mobile Safari
            nativeEl.type = 'text';
            nativeEl.setSelectionRange(0, nativeEl.value.length);
          } else {
            nativeEl.select();
          }
        }
      } else {
        const nativeEl: HTMLInputElement = this.el.nativeElement;
        if (nativeEl) {
          if (!window.getSelection().toString()) {
            // Required for mobile Safari
            nativeEl.type = 'text';
            nativeEl.setSelectionRange(0, nativeEl.value.length);
          } else {
            nativeEl.select();
          }
        }
      }
    }, 500);
  }
}
